

















export default {
  props: ['module', 'active', 'click'],
};

